module.exports = __webpack_public_path__ + "static/media/green-eraser.a211c1fe.svg";